<template>
  <div class="page-category">
    <fn-cms-section-loader
      v-if="page?.content?.content_slots?.a?.sections"
      :sections="page.content.content_slots.a.sections"
    />

    <fn-cms-section-loader
      v-if="page?.content?.content_slots?.b?.sections"
      :sections="page.content.content_slots.b.sections"
    />

    <template v-if="flatNodes?.length">
      <fn-section
        constrained="l"
        padding-top="m"
        padding-bottom="s"
      >
        <fn-headline
          type="h2"
          size="h3"
        >
          {{ $t('category.nodes.headline') }}
        </fn-headline>
      </fn-section>

      <fn-section
        constrained="l"
        padding-bottom="m"
      >
        <fn-list
          class="category-links-container"
          unstyled
          horizontal
        >
          <li
            v-for="node in flatNodes"
            :id="`category-link-${node.id}`"
            :key="node.id"
            class="category-link-item"
          >
            <fn-link :to="node.url">
              {{ node.title }}
            </fn-link>
          </li>
        </fn-list>
      </fn-section>
    </template>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  page: Record<string, any>;
  nodes?: Record<string, any>;
}>();

const flatNodes = computed(() => {
  if (!props.nodes?.nodes?.length) {
    return [];
  }
  const flatNodes = [];
  props.nodes.nodes.forEach((node) => {
    flatNodes.push(node);
    if (node.nodes?.length) {
      node.nodes.forEach((child) => {
        flatNodes.push(child);
      });
    }
  });
  return flatNodes;
});

const route = useRoute();
useScrollToHash(route);
</script>

<style lang="scss" scoped>
:deep(.grid-item--category) {
  margin-bottom: $space;
}
:deep(li.category-link-item) {
  flex: 0 0 calc(50% - 16px);
  margin-right: 16px;
  margin-bottom: $pad;

  @include bp(m) {
    flex: 0 0 calc(25% - 16px);
  }
}
</style>
